interface PropsTypes {
  img: string,
  title: string,
  desc: string,
  children: React.ReactNode
}

export default function RegistrationBox({ img, title, desc, children }: PropsTypes) {

  return (
    <div className="w-full">
      <img
        src={img}
        alt="Hero small logo"
        className="mb-6 mx-auto h-20 w-20"
      />
      <h1 className="sm:text-[30px] text-[25px] font-[500] text-center sm:leading-[48px] leading-[40px] text-black mb-2">
        {title}
      </h1>
      <p className="text-center text-gray-500 body1">
        {desc}
      </p>

      {children}
    </div>
  )
}
